import type { FlowHandler, ActionMenuItem } from './index';
import { listFlows } from '@/services/mockPurchaseFlowService';
import type { PurchaseFlow } from '@/types/purchaseFlow';

// Cache for recent flows (refreshed on each menu open)
let cachedFlows: PurchaseFlow[] = [];
let cacheTimestamp = 0;
const CACHE_TTL = 3000; // 3 seconds

async function getRecentFlows(): Promise<PurchaseFlow[]> {
  if (Date.now() - cacheTimestamp < CACHE_TTL && cachedFlows.length > 0) {
    return cachedFlows;
  }
  try {
    const result = await listFlows();
    cachedFlows = result.flows;
    cacheTimestamp = Date.now();
    return cachedFlows;
  } catch {
    return cachedFlows;
  }
}

function flowLabel(flow: PurchaseFlow): string {
  const poNumber = (flow.stage_data as Record<string, unknown>)?.po_number as string;
  if (poNumber) return poNumber;
  return `Flow ${flow.flow_id.slice(0, 8)}`;
}

const STATUS_ICONS: Record<string, string> = {
  active: '🟢',
  paused: '🟡',
  completed: '✅',
  cancelled: '🔴',
};

export const purchaseOrderHandler: FlowHandler = {
  getMenuItems: () => {
    // Trigger async fetch so cache is warm for the submenu
    getRecentFlows();

    const recentFlowChildren: ActionMenuItem[] = cachedFlows.slice(0, 10).map(flow => ({
      icon: STATUS_ICONS[flow.status] || '⚪',
      label: flowLabel(flow),
      onClick: () => {},
      navigateTo: `/app/psi/purchases?flow=${flow.flow_id}`,
    }));

    if (recentFlowChildren.length === 0) {
      recentFlowChildren.push({
        icon: '💤',
        label: 'No recent flows',
        onClick: () => {},
      });
    }

    return [
      {
        icon: '💬',
        label: 'New PO Flow',
        onClick: () => {},
        navigateTo: '/app/psi/purchases?flow=new',
      },
      {
        icon: '📂',
        label: 'Recent Flows',
        onClick: () => {},
        children: recentFlowChildren,
      },
    ];
  },
};
